module.exports = __webpack_public_path__ + "static/media/orange-down-arrow.86237cc2.svg";